import React, { useEffect, useRef, useState } from 'react'
import './forstartupshero.css'
import Header from '../Header/header'
import CountUp from "react-countup";
import { FaArrowRightLong } from 'react-icons/fa6';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

function Forstartupshero() {
    
    const [hasStarted, setHasStarted] = useState(false)
    const sectionRef = useRef(null)

    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, [])

    //on scroll activate counter
    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;

            const sectionTop = sectionRef.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;

            if (sectionTop < windowHeight * 0.8 && !hasStarted) {
                setHasStarted(true);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [hasStarted]);

    const counters = [
        { id: 0, value: 35, label: "Developers" },
        { id: 1, value: 30, label: "Startups" },
        { id: 2, value: 7, label: "Projects" },
    ];


    return (
        <div className='forstartupsheromain'>
            <Header />
            <div className='startupshero-content'>
                <div className="pagetitles" data-aos="fade" data-aos-duration="1500">
                    <span>For Startups</span>
                    <h1>Make your ideas happen</h1>
                    <p>Empower your creativity with tools and support designed to transform your ideas into impactful solutions. Let's build something extraordinary together.</p>
                    <button className="estimation-button">
                        <p>Learn More</p>
                        <div className="arrow-circle">
                            <FaArrowRightLong />
                        </div>
                    </button>
                </div>

                <div className="achievements-counter" ref={sectionRef} data-aos='fade-up'>
                    {counters.map((counter) => (
                        <div className="counter-item" key={counter.id}>
                            <li>
                                <p>
                                    {hasStarted ? (
                                        <CountUp start={0} end={counter.value} duration={4.5} />
                                    ) : (
                                        0
                                    )}
                                </p>
                                <span>+</span>
                            </li>
                            <h3>{counter.label}</h3>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default Forstartupshero